module.exports = __webpack_public_path__ + "static/media/fecha_derecha.7dc9745f.gif";